module.exports = __webpack_public_path__ + "img/quebec_city.fc9a74c9.jpg";